import { ApplicationDefinition } from './types';
import appClient from './AppClient';
import { endpoints } from '../../../config';

export default class ApplicationDefinitionsService {
    async getApplicationDefinitionsForProject(projectId: string, state: string): Promise<ApplicationDefinition[]> {
        const url = `${endpoints.manageUrl}projects/${encodeURIComponent(
            projectId
        )}/iota/applications?state=${encodeURIComponent(state)}`;
        const result = await appClient.get<ApplicationDefinition[]>(url);

        if (result.isErr()) {
            throw result.error;
        }

        return result.value || [];
    }
}
